import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as fbSignOut,
  onAuthStateChanged,
  updateProfile,
  type User,
} from 'firebase/auth';
import { auth } from './index';

const FIREBASE_ERRORS_AR: Record<string, string> = {
  'auth/email-already-in-use': 'الإيميل ده مسجّل قبل كده — جرّب تسجل دخول',
  'auth/invalid-email': 'الإيميل غير صالح',
  'auth/user-disabled': 'الحساب ده متعطّل',
  'auth/user-not-found': 'مفيش حساب بالإيميل ده',
  'auth/wrong-password': 'كلمة المرور غلط',
  'auth/invalid-credential': 'الإيميل أو كلمة المرور غلط',
  'auth/invalid-login-credentials': 'الإيميل أو كلمة المرور غلط',
  'auth/too-many-requests': 'محاولات كتير — استنى شوية وجرّب تاني',
  'auth/network-request-failed': 'مشكلة في النت — تأكد من الاتصال',
  'auth/weak-password': 'كلمة المرور ضعيفة (لازم 6 حروف على الأقل)',
};

export function firebaseErrorToAr(err: any): string {
  const code = err?.code || '';
  return FIREBASE_ERRORS_AR[code] || err?.message || 'حصل خطأ غير متوقع';
}

export async function signUp(email: string, password: string, displayName?: string) {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  if (displayName && cred.user) {
    await updateProfile(cred.user, { displayName });
  }
  return cred.user;
}

export async function signIn(email: string, password: string) {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
}

export async function signOut() {
  await fbSignOut(auth);
}

export function onAuthChange(cb: (user: User | null) => void) {
  return onAuthStateChanged(auth, cb);
}
